var maxParcels = 25;

function recalculateMultipleBoxes() {
    var parcelCount = $('.new-shipment .parcels .parcel').length;
    // console.log(parcelCount, maxParcels, maxParcels-parcelCount);

    $('.new-shipment .add-multiple-boxes select').html('<option value="" disabled selected hidden>Add Boxes</option>');
    for (let i = 2; i <= maxParcels-parcelCount; i++) {
        $('.new-shipment .add-multiple-boxes select').append(`<option value="${i}">Add ${i} Boxes</option>`);
    }
}

$('body').on('click', '.new-shipment-trigger', function () {
    $(this).blur();

    // hide the new address options
    $('.new-shipment .new-address input, .new-shipment .new-address select').each(function () {
        var input = $(this);
        input.val('');
        input.prop('disabled', true);
        input.removeClass('required');
    });
    $('.new-shipment .new-address').addClass('hidden');

    // reset the selected address

    $('.selected-address [data-input]').html('');
    $('.selected-address').addClass('hidden');


    // hide the new parcel options
    $('.new-shipment .new-parcel input, .new-shipment .new-parcel select').each(function () {
        var input = $(this);
        input.val('');
        input.prop('disabled', true);
        input.removeClass('required');
    });
    $('.new-shipment .new-parcel').addClass('hidden');


    // reset the rates
    $('.new-shipment .shipping-rates .rates').html('');

    $('.new-shipment .purchase-label').addClass('hidden');

    openSlideout('.new-shipment');
    recalculateMultipleBoxes();
    return false;
});


// searching the from address
$('body').on('keyup', '.new-shipment .from-address .selector input', function (e) {
    var $this = $(this);
    var selector = $this.parents('.selector');

    var navigationKeys = [40, 38, 13];
    if (navigationKeys.indexOf(e.keyCode) !== -1) {
        return false;
    }

    if ($this.val().length < 3) {
        $('.new-shipment .from-address .selector .selector-results ul').html('');
        $('.new-shipment .from-address .selector .selector-results').addClass('hidden');
        return false;
    }

    $.ajax({
        type: 'POST',
        url: selector.attr('data-url'),
        data: {
            'search': $this.val(),
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': 'GET'
        },
        dataType: 'json',
        success: function (data) {
            console.log(data);
            $('.new-shipment .from-address .selector .selector-results ul').html('');
            if (!data.success) {
                $('.new-shipment .from-address .selector .selector-results').addClass('hidden');
                return false;
            }

            $('.new-shipment .from-address .selector .selector-results').removeClass('hidden');
            $.each(data.from_addresses, function (index, address) {
                $('.new-shipment .from-address .selector ul').append(`<li>
				<a href="#"
                class="select-from-address"
                data-mode="from_address"
                data-from_address="${address.from_address}"
                data-street="${address.street}"
                data-apt="${address.apt}"
                data-city="${address.city}"
                data-state="${address.state}"
                data-zip="${address.zip}"
                data-country="${address.country}"
                data-residential="${address.residential}"
				>
                    ${address.street} - ${address.zip} <br>
                    ${address.phone ? address.phone : ''}
                    ${address.email ? address.email : ''}
				</a>
			</li>`);
            });
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});

$('body').on('focus', '.new-shipment .from-address .selector input', function () {
    closeDropdown($('.new-shipment .from-address .selector .selector-results').attr('data-dropdown'));
    if ($('.new-shipment .from-address .selector .selector-results ul li').length) {
        $('.new-shipment .from-address .selector .selector-results').removeClass('hidden');
    }

    $('.new-shipment .new-from-address input, .new-shipment .new-from-address select').each(function () {
        var input = $(this);
        input.val('');
        input.prop('disabled', true);
        input.removeClass('required');
    });

    $('.new-shipment .new-from-address').addClass('hidden');
    return false;
});

$('body').on('keydown', '.new-shipment .from-address .selector input', function (e) {
    var scrollTop = $('.new-shipment .from-address .selector .selector-results ul').scrollTop();
    // console.log(scrollTop);
    var element = null;

    // down arrow
    if (e.keyCode === 40) {
        if (!$('.new-shipment .from-address .selector .selector-results ul li').length) {
            return false;
        }

        // if we dont have any selected
        if (!$('.new-shipment .from-address .selector .selector-results ul li.selected').length) {
            $('.new-shipment .from-address .selector .selector-results ul li').each(function () {
                var $this = $(this);
                if (($this.position().top + $this.height()) >= 0) {
                    element = $this;
                    return false;
                }
            });

            $('.new-shipment .from-address .selector .selector-results ul li').removeClass('selected');
            element.addClass('selected');
            $('.new-shipment .from-address .selector .selector-results ul').scrollTop(element.position().top + scrollTop);
            return false;
        }

        // if we have a next
        if ($('.new-shipment .from-address .selector .selector-results ul li.selected').next().length) {
            element = $('.new-shipment .from-address .selector .selector-results ul li.selected').next();

            $('.new-shipment .from-address .selector .selector-results ul li').removeClass('selected');
            element.addClass('selected');
            $('.new-shipment .from-address .selector .selector-results ul').scrollTop(element.position().top + scrollTop);
            return false;
        }
        return false;
    }


    // up arrow
    if (e.keyCode === 38) {
        if (!$('.new-shipment .from-address .selector .selector-results ul li.selected').length) {
            return false;
        }

        // if we have a previous
        if ($('.new-shipment .from-address .selector .selector-results ul li.selected').prev().length) {
            element = $('.new-shipment .from-address .selector .selector-results ul li.selected').prev();

            $('.new-shipment .from-address .selector .selector-results ul li').removeClass('selected');
            element.addClass('selected');
            $('.new-shipment .from-address .selector .selector-results ul').scrollTop(element.position().top + scrollTop);
            return false;
        }
    }

    // enter arrow
    if (e.keyCode === 13) {
        if (!$('.new-shipment .from-address .selector .selector-results ul li.selected').length) {
            return false;
        }

        element = $('.new-shipment .from-address .selector .selector-results ul li.selected');
        element.find('a').trigger('click');

        return false;
    }
});

$('body').on('click', '.new-shipment .from-address .select-from-address', function () {
    var $this = $(this);

    $('.selected-from-address [data-input="street"]').html($this.attr('data-street'));
    $('.selected-from-address [data-input="apt"]').html($this.attr('data-apt'));
    $('.selected-from-address [data-input="city"]').html($this.attr('data-city'));
    $('.selected-from-address [data-input="state"]').html($this.attr('data-state'));
    $('.selected-from-address [data-input="zip"]').html($this.attr('data-zip'));
    $('.selected-from-address [data-input="country"]').html($this.attr('data-country'));

    $('.new-shipment .from-address').attr('data-mode', $this.attr('data-mode'));
    $('.new-shipment .from-address').attr('data-from_address', $this.attr('data-from_address'));

    $('.new-shipment .new-from-address input, .new-shipment .new-from-address select').each(function () {
        var input = $(this);
        input.val('');
        input.prop('disabled', true);
        input.removeClass('required');
    });

    $('.new-shipment .new-from-address').addClass('hidden');
    closeDropdown();
    return false;
});

$('body').on('click', '.new-shipment .add-from-address', function() {
    $('.new-shipment .from-address').attr('data-mode', 'new');
    $('.new-shipment .from-address').attr('data-from_address', '');

    $('.new-shipment .new-from-address input, .new-shipment .new-from-address select').each(function () {
        var input = $(this);
        input.prop('disabled', false);
        if (input.attr('data-required')) {
            input.addClass('required');
        }
    });

    $('.new-shipment .new-from-address').removeClass('hidden');
    $('.new-shipment .new-from-address [name="street"]').focus();

    $('.selected-from-address [data-input]').html('');
    $('.selected-address').addClass('hidden');
    
    return false;
});

// adding a new address
$('body').on('click', '.new-shipment .add-shipment-from-address-trigger', function () {

    var error = false;

    $('.new-shipment .new-from-address').find('.required').each(function () {
        if ($(this).val() === '') {
            error = true;
        }
    });

    if (error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }

    loading();
    $.ajax({
        type: 'POST',
        url: $('.new-shipment .new-from-address').attr('data-url'),
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            street: $('.new-shipment .new-from-address [name="street"]').val(),
            apt: $('.new-shipment .new-from-address [name="apt"]').val(),
            city: $('.new-shipment .new-from-address [name="city"]').val(),
            state: $('.new-shipment .new-from-address [name="state"]').val(),
            zip: $('.new-shipment .new-from-address [name="zip"]').val(),
            country: $('.new-shipment .new-from-address [name="country"]').val(),
            residential: $('.new-shipment .new-from-address [name="residential"]').prop('checked')
        },
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();

            if (!data.success) {
                showError('Error', data.message);
                return false;
            }

            if (data.from_address) {
                $('.new-shipment .from-address').attr('data-mode', 'from_address');
                $('.new-shipment .from-address').attr('data-from_address', data.from_address);

                $('.new-shipment .new-from-address').addClass('hidden');

                $('.selected-from-address [data-input="street"]').html(data.from_address.street);
                $('.selected-from-address [data-input="apt"]').html(data.from_address.apt);
                $('.selected-from-address [data-input="city"]').html(data.from_address.city);
                $('.selected-from-address [data-input="state"]').html(data.from_address.state);
                $('.selected-from-address [data-input="zip"]').html(data.from_address.zip);
                $('.selected-from-address [data-input="country"]').html(data.from_address.country);
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});


// searching the shipping address
$('body').on('keyup', '.new-shipment .shipping-address .selector input', function (e) {
    var $this = $(this);
    var selector = $this.parents('.selector');

    var navigationKeys = [40, 38, 13];
    if (navigationKeys.indexOf(e.keyCode) !== -1) {
        return false;
    }

    if ($this.val().length < 3) {
        $('.new-shipment .shipping-address .selector .selector-results ul').html('');
        $('.new-shipment .shipping-address .selector .selector-results').addClass('hidden');
        return false;
    }

    $.ajax({
        type: 'POST',
        url: selector.attr('data-url'),
        data: {
            'search': $this.val(),
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': 'GET'
        },
        dataType: 'json',
        success: function (data) {
            console.log(data);
            $('.new-shipment .shipping-address .selector .selector-results ul').html('');
            if (!data.success) {
                $('.new-shipment .shipping-address .selector .selector-results').addClass('hidden');
                return false;
            }

            $('.new-shipment .shipping-address .selector .selector-results').removeClass('hidden');
            $.each(data.addresses, function (index, address) {
                $('.new-shipment .shipping-address .selector ul').append(`<li>
				<a href="#"
                class="select-shipping-address"
                data-mode="address"
                data-address="${address.address}"
                data-nickname="${address.nickname}"
                data-full_name="${address.full_name}"
                data-company="${address.company}"
                data-phone="${address.phone}"
                data-street="${address.street}"
                data-apt="${address.apt}"
                data-city="${address.city}"
                data-state="${address.state}"
                data-zip="${address.zip}"
                data-country="${address.country}"
                data-residential="${address.residential}"
				>
                    ${address.nickname} - ${address.full_name}<br>
                    ${address.street} - ${address.zip} <br>
                    ${address.company ? address.company : ''}
				</a>
			</li>`);
            });
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});

$('body').on('focus', '.new-shipment .shipping-address .selector input', function () {
    closeDropdown($('.new-shipment .shipping-address .selector .selector-results').attr('data-dropdown'));
    if ($('.new-shipment .shipping-address .selector .selector-results ul li').length) {
        $('.new-shipment .shipping-address .selector .selector-results').removeClass('hidden');
    }

    $('.new-shipment .new-address input, .new-shipment .new-address select').each(function () {
        var input = $(this);
        input.val('');
        input.prop('disabled', true);
        input.removeClass('required');
    });

    $('.new-shipment .new-address').addClass('hidden');
    return false;
});

$('body').on('keydown', '.new-shipment .shipping-address .selector input', function (e) {
    var scrollTop = $('.new-shipment .shipping-address .selector .selector-results ul').scrollTop();
    // console.log(scrollTop);
    var element = null;

    // down arrow
    if (e.keyCode === 40) {
        if (!$('.new-shipment .shipping-address .selector .selector-results ul li').length) {
            return false;
        }

        // if we dont have any selected
        if (!$('.new-shipment .shipping-address .selector .selector-results ul li.selected').length) {
            $('.new-shipment .shipping-address .selector .selector-results ul li').each(function () {
                var $this = $(this);
                if (($this.position().top + $this.height()) >= 0) {
                    element = $this;
                    return false;
                }
            });

            $('.new-shipment .shipping-address .selector .selector-results ul li').removeClass('selected');
            element.addClass('selected');
            $('.new-shipment .shipping-address .selector .selector-results ul').scrollTop(element.position().top + scrollTop);
            return false;
        }

        // if we have a next
        if ($('.new-shipment .shipping-address .selector .selector-results ul li.selected').next().length) {
            element = $('.new-shipment .shipping-address .selector .selector-results ul li.selected').next();

            $('.new-shipment .shipping-address .selector .selector-results ul li').removeClass('selected');
            element.addClass('selected');
            $('.new-shipment .shipping-address .selector .selector-results ul').scrollTop(element.position().top + scrollTop);
            return false;
        }
        return false;
    }


    // up arrow
    if (e.keyCode === 38) {
        if (!$('.new-shipment .shipping-address .selector .selector-results ul li.selected').length) {
            return false;
        }

        // if we have a previous
        if ($('.new-shipment .shipping-address .selector .selector-results ul li.selected').prev().length) {
            element = $('.new-shipment .shipping-address .selector .selector-results ul li.selected').prev();

            $('.new-shipment .shipping-address .selector .selector-results ul li').removeClass('selected');
            element.addClass('selected');
            $('.new-shipment .shipping-address .selector .selector-results ul').scrollTop(element.position().top + scrollTop);
            return false;
        }
    }

    // enter arrow
    if (e.keyCode === 13) {
        if (!$('.new-shipment .shipping-address .selector .selector-results ul li.selected').length) {
            return false;
        }

        element = $('.new-shipment .shipping-address .selector .selector-results ul li.selected');
        element.find('a').trigger('click');

        return false;
    }
});

$('body').on('click', '.new-shipment .shipping-address .select-shipping-address', function () {
    var $this = $(this);

    $('.new-shipment .new-address input, .new-shipment .new-address select').each(function () {
        var input = $(this);
        input.val('');
        input.prop('disabled', true);
        input.removeClass('required');
    });

    $('.new-shipment .new-address').addClass('hidden');
    $('.new-shipment .shipping-address').attr('data-address', $this.attr('data-address'));

    $('.selected-address [data-input="nickname"]').html($this.attr('data-nickname'));
    $('.selected-address [data-input="full_name"]').html($this.attr('data-full_name'));
    $('.selected-address [data-input="company"]').html($this.attr('data-company'));
    $('.selected-address [data-input="phone"]').html($this.attr('data-phone'));
    $('.selected-address [data-input="street"]').html($this.attr('data-street'));
    $('.selected-address [data-input="apt"]').html($this.attr('data-apt'));
    $('.selected-address [data-input="city"]').html($this.attr('data-city'));
    $('.selected-address [data-input="state"]').html($this.attr('data-state'));
    $('.selected-address [data-input="zip"]').html($this.attr('data-zip'));
    $('.selected-address [data-input="country"]').html($this.attr('data-country'));
    $('.selected-address').removeClass('hidden');

    closeDropdown();
    return false;
});

$('body').on('click', '.new-shipment .add-address', function () {
    $('.new-shipment .shipping-address').attr('data-address', 'new');


    $('.new-shipment .new-address input, .new-shipment .new-address select').each(function () {
        var input = $(this);
        input.prop('disabled', false);
        if (input.attr('data-required')) {
            input.addClass('required');
        }
    });

    $('.new-shipment .new-address').removeClass('hidden');
    $('.new-shipment .new-address [name="nickname"]').focus();

    $('.selected-address [data-input]').html('');
    $('.selected-address').addClass('hidden');
    return false;
});

// adding a new address
$('body').on('click', '.new-shipment .add-shipment-address-trigger', function() {
    console.log('submit address');

    var error = false;

    $('.new-shipment .new-address').find('.required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }

    loading();
    $.ajax({
        type: 'POST',
        url: $('.new-shipment .new-address').attr('data-url'),
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            nickname: $('.new-shipment .new-address [name="nickname"]').val(),
            first_name: $('.new-shipment .new-address [name="first_name"]').val(),
            last_name: $('.new-shipment .new-address [name="last_name"]').val(),
            company: $('.new-shipment .new-address [name="company"]').val(),
            email: $('.new-shipment .new-address [name="email"]').val(),
            phone: $('.new-shipment .new-address [name="phone"]').val(),
            street: $('.new-shipment .new-address [name="street"]').val(),
            apt: $('.new-shipment .new-address [name="apt"]').val(),
            city: $('.new-shipment .new-address [name="city"]').val(),
            state: $('.new-shipment .new-address [name="state"]').val(),
            zip: $('.new-shipment .new-address [name="zip"]').val(),
            country: $('.new-shipment .new-address [name="country"]').val(),
            residential: $('.new-shipment .new-address [name="residential"]').prop('checked')
        },
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();

            if (!data.success) {
                showError('Error', data.message);
                return false;
            }

            if(data.address) {
                $('.new-shipment .shipping-address').attr('data-address', data.address.address);

                $('.new-shipment .new-address').addClass('hidden');

                $('.selected-address [data-input="nickname"]').html(data.address.nickname);
                $('.selected-address [data-input="full_name"]').html(data.address.full_name);
                $('.selected-address [data-input="company"]').html(data.address.company);
                $('.selected-address [data-input="phone"]').html(data.address.phone);
                $('.selected-address [data-input="street"]').html(data.address.street);
                $('.selected-address [data-input="apt"]').html(data.address.apt);
                $('.selected-address [data-input="city"]').html(data.address.city);
                $('.selected-address [data-input="state"]').html(data.address.state);
                $('.selected-address [data-input="zip"]').html(data.address.zip);
                $('.selected-address [data-input="country"]').html(data.address.country);
                $('.selected-address').removeClass('hidden');
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
    
    return false;
});


// when changing the parcel
$('body').on('change', '.new-shipment select[name="parcel"]', function () {
    var $this = $(this);
    var parcel = $this.parents('.parcel');
    var value = $this.val();

    if (value === 'new') {
        $('.new-parcel input, .new-parcel select', parcel).each(function () {
            var input = $(this);
            input.prop('disabled', false);
            if (input.attr('data-required')) {
                input.addClass('required');
            }
        });

        $('.new-parcel', parcel).removeClass('hidden');
        $('.new-parcel [name="name"]', parcel).focus();

        $('.new-parcel [name="distance_unit"]', parcel).val('in');
        $('.new-parcel [name="mass_unit"]', parcel).val('lb');

        $('[name="parcel_weight"]', parcel).removeClass('required').val('').attr('disabled', true).parents('.parcel-option').removeClass('filled');
        $('[name="parcel_mass_unit"]', parcel).removeClass('required').val('').attr('disabled', true);
    } else {
        $('[name="parcel_weight"]', parcel).val($('option:selected', $this).attr('data-weight')).addClass('required').attr('disabled', false);
        $('[name="parcel_mass_unit"]', parcel).val($('option:selected', $this).attr('data-mass_unit')).addClass('required').attr('disabled', false);
        $('.parcel-option', parcel).addClass('filled');

        $('.new-parcel input, .new-parcel select', parcel).each(function () {
            var input = $(this);
            input.val('');
            input.prop('disabled', true);
            input.removeClass('required');
        });

        $('.new-parcel', parcel).addClass('hidden');
    }
});

// adding a new parcel
$('body').on('click', '.new-shipment .add-shipment-parcel-trigger', function () {
    var $this = $(this);
    var parcel = $this.parents('.parcel');

    var error = false;

    $('.new-parcel', parcel).find('.required').each(function () {
        if ($(this).val() === '') {
            error = true;
        }
    });

    if (error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }

    loading();
    $.ajax({
        type: 'POST',
        url: $('.new-shipment .new-parcel').attr('data-url'),
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            name: $('.new-parcel [name="name"]', parcel).val(),
            length: $('.new-parcel [name="length"]', parcel).val(),
            width: $('.new-parcel [name="width"]', parcel).val(),
            height: $('.new-parcel [name="height"]', parcel).val(),
            distance_unit: $('.new-parcel [name="distance_unit"]', parcel).val(),
            weight: $('.new-parcel [name="weight"]', parcel).val(),
            mass_unit: $('.new-parcel [name="mass_unit"]', parcel).val()
        },
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();

            if (!data.success) {
                showError('Error', data.message);
                return false;
            }

            if (data.parcel) {
                var option = $('<option>', {
                    'value': data.parcel.parcel,
                    'html': `${data.parcel.name} (${data.parcel.full_size} - ${data.parcel.full_weight})`
                });

                $('.new-shipment select[name="parcel"]').append(option);
                $('select[name="parcel"]', parcel).val(data.parcel.parcel);

                $('.new-parcel', parcel).addClass('hidden');
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});

$('body').on('change', '.new-shipment .add-multiple-boxes select', function() {
    var $this = $(this);
    for (let i = 0; i < $this.val(); i++) {
        var parcel = $this.parents('.parcels').find('.parcel').last();
        var newParcel = parcel.clone();

        $('input, select', newParcel).each(function () {
            var input = $(this);
            input.val(parcel.find(`[name="${input.attr('name')}"]`).val());
        });
        newParcel.insertAfter(parcel);
    }

    recalculateMultipleBoxes();
    
    return false;
});

$('body').on('click', '.new-shipment .add-box-trigger', function() {
    var $this = $(this);
    var parcel = $this.parents('.parcels').find('.parcel').last();
    var newParcel = parcel.clone();
    $('input, select', newParcel).each(function() {
        var input = $(this);
        input.val(parcel.find(`[name="${input.attr('name')}"]`).val());
    });
    newParcel.insertAfter(parcel);

    if ($this.parents('.parcels').find('.parcel').length >= maxParcels) {
        $this.hide();
    }

    if ($this.parents('.parcels').find('.parcel').length >= (maxParcels-1)) {
        $('.new-shipment .add-multiple-boxes').hide();
    }

    recalculateMultipleBoxes();

    return false;
});

$('body').on('click', '.new-shipment .remove-parcel-trigger', function() {
    var $this = $(this);
    var parcel = $this.parents('.parcel');
    if ($this.parents('.parcels').find('.parcel').length == 1) {
        return false;
    }

    parcel.remove();

    $('.new-shipment .add-box-trigger').show();

    if ($('.new-shipment .parcels .parcel').length < (maxParcels-1)) {
        $('.new-shipment .add-multiple-boxes').show();
    }

    recalculateMultipleBoxes();

    return false;
});


// calculate rates
$('body').on('click', '.new-shipment .calculate-rates', function() {
    var $this = $(this);
    var error = false;

    var payload = {};
    payload['_token'] = $('meta[name="csrf-token"]').attr('content');
    payload['_method'] = 'GET';
    payload['address'] = $('.new-shipment .shipping-address').attr('data-address');
    // payload['parcel'] = $('.new-shipment select[name="parcel"]').val();
    payload['reference_1'] = $('.new-shipment [name="reference_1"]').val();
    payload['reference_2'] = $('.new-shipment [name="reference_2"]').val();

    switch ($('.new-shipment .from-address').attr('data-mode')) {       
        case 'from_address':
            payload['from_address'] = $('.new-shipment .from-address').attr('data-from_address');
            break;

        case 'new':
            payload['from_address'] = 'new';

            $('.new-shipment .new-from-address').find('.required').each(function () {
                if ($(this).val() === '') {
                    error = true;
                }
            });

            if (error) {
                showError('Error', 'Please fill out all required fields');
                return false;
            }

            payload['from_street'] = $('.new-shipment .new-from-address [name="street"]').val();
            payload['from_apt'] = $('.new-shipment .new-from-address [name="apt"]').val();
            payload['from_city'] = $('.new-shipment .new-from-address [name="city"]').val();
            payload['from_state'] = $('.new-shipment .new-from-address [name="state"]').val();
            payload['from_zip'] = $('.new-shipment .new-from-address [name="zip"]').val();
            payload['from_country'] = $('.new-shipment .new-from-address [name="country"]').val();
            payload['from_residential'] = $('.new-shipment .new-from-address [name="residential"]').prop('checked');
            break;
    }

    if (!$('.new-shipment .shipping-address').attr('data-address')) {
        showError('Error', 'Please choose a shipping address');
        return false;
    }

    if ($('.new-shipment .shipping-address').attr('data-address') == 'new') {
        $('.new-shipment .new-address').find('.required').each(function () {
            if ($(this).val() === '') {
                error = true;
            }
        });

        if (error) {
            showError('Error', 'Please fill out all required fields');
            return false;
        }

        payload['nickname'] = $('.new-shipment .new-address [name="nickname"]').val();
        payload['first_name'] = $('.new-shipment .new-address [name="first_name"]').val();
        payload['last_name'] = $('.new-shipment .new-address [name="last_name"]').val();
        payload['company'] = $('.new-shipment .new-address [name="company"]').val();
        payload['email'] = $('.new-shipment .new-address [name="email"]').val();
        payload['phone'] = $('.new-shipment .new-address [name="phone"]').val();
        payload['street'] = $('.new-shipment .new-address [name="street"]').val();
        payload['apt'] = $('.new-shipment .new-address [name="apt"]').val();
        payload['city'] = $('.new-shipment .new-address [name="city"]').val();
        payload['state'] = $('.new-shipment .new-address [name="state"]').val();
        payload['zip'] = $('.new-shipment .new-address [name="zip"]').val();
        payload['country'] = $('.new-shipment .new-address [name="country"]').val();
        payload['residential'] = $('.new-shipment .new-address [name="residential"]').prop('checked');
    }

    var parcels = [];
    // if (!$('.new-shipment select[name="parcel"]').length) {
    //     showError('Error', 'Please choose a parcel size');
    //     return false;
    // }

    $('.new-shipment .parcels .parcel').each(function() {
        var parcel = $(this);

        parcel.find('.required').each(function () {
            if ($(this).val() === '') {
                error = true;
            }
        });

        if (error) {
            showError('Error', 'Please fill out all required parcel fields');
            return false;
        }

        var parcelData = {};
        parcelData['parcel'] = $('select[name="parcel"]', parcel).val();
        parcelData['weight'] = $('[name="parcel_weight"]', parcel).val();
        parcelData['mass_unit'] = $('[name="parcel_mass_unit"]', parcel).val();

        if ($('select[name="parcel"]', parcel).val() == 'new') {
            $('.new-parcel', parcel).find('.required').each(function () {
                if ($(this).val() === '') {
                    error = true;
                }
            });

            if (error) {
                showError('Error', 'Please fill out all required fields');
                return false;
            }

            parcelData['name'] = $('.new-parcel [name="name"]', parcel).val();
            parcelData['length'] = $('.new-parcel [name="length"]', parcel).val();
            parcelData['width'] = $('.new-parcel [name="width"]', parcel).val();
            parcelData['height'] = $('.new-parcel [name="height"]', parcel).val();
            parcelData['distance_unit'] = $('.new-parcel [name="distance_unit"]', parcel).val();
            parcelData['weight'] = $('.new-parcel [name="weight"]', parcel).val();
            parcelData['mass_unit'] = $('.new-parcel [name="mass_unit"]', parcel).val();
        }

        parcels.push(parcelData);
    });

    payload['parcels'] = parcels;

    // console.log(payload);
    // console.log($this);
    // return false;

    if(error) {
        return false;
    }

    loading();
    $.ajax({
        type: 'POST',
        url: $this.attr('href'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();

            if (!data.success) {
                showError('Error', data.message);
                return false;
            }

            if(data.rates) {
                $('.new-shipment .shipping-rates .rates').html('');
                $.each(data.rates, function(index, rate) {
                    console.log(index);
                    $('.new-shipment .shipping-rates .rates').append(`<a
                    class="rate select-shipping-rate"
                    data-object_id="${rate.object_id}"
                    data-carrier="${rate.carrier}"
                    data-address="${data.address.address}"
                    data-nickname="${data.address.nickname}"
                    data-first_name="${data.address.first_name}"
                    data-last_name="${data.address.last_name}"
                    data-full_name="${data.address.full_name}"
                    data-company="${data.address.company}"
                    data-email="${data.address.email}"
                    data-phone="${data.address.phone}"
                    data-street="${data.address.street}"
                    data-apt="${data.address.apt}"
                    data-city="${data.address.city}"
                    data-state="${data.address.state}"
                    data-zip="${data.address.zip}"
                    data-country="${data.address.country}"
                    data-residential="${data.address.residential}"
                    data-parcels='${JSON.stringify(data.parcels)}'
                    data-reference_1="${data.reference_1}"
                    data-reference_2="${data.reference_2}"
                    >
                        <div class="dot"></div>
                        <figure>
                            <img src="images/icons/${rate.carrier}.svg" alt="${rate.carrier}">
                        </figure>
                        <div class="rate-details">
                            <h3>${rate.service_level}</h3>
                            <p class="price_parsed">${rate.price_parsed}</p>
                            <p class="estimated_days">Estimated Days: ${rate.days}</p>
                            <p class="terms">${rate.terms}</p>
                        </div>
                    </a>`);
                });

                $('.new-shipment .purchase-label').removeClass('hidden');
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
    
    return false;
});

// select shipping rate
$('body').on('click', '.new-shipment .rates .select-shipping-rate', function () {
    $('.new-shipment .rates .select-shipping-rate').removeClass('selected');
    $(this).addClass('selected');
    return false;
});


// purchase labels
$('body').on('click', '.new-shipment .purchase-shipping-label', function () {
    var $this = $(this);

    if (!$('.new-shipment .rates .select-shipping-rate.selected').length) {
        showError('Error', 'Please select a shipping rate');
        return false;
    }

    loading();
    $.ajax({
        type: 'POST',
        url: $this.attr('href'),
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            rate: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-object_id'),
            address: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-address'),
            nickname: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-nickname'),
            first_name: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-first_name'),
            last_name: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-last_name'),
            full_name: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-full_name'),
            company: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-company'),
            email: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-email'),
            phone: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-phone'),
            street: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-street'),
            apt: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-apt'),
            city: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-city'),
            state: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-state'),
            zip: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-zip'),
            country: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-country'),
            residential: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-residential'),
            reference_1: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-reference_1'),
            reference_2: $('.new-shipment .rates .select-shipping-rate.selected').attr('data-reference_2'),
            parcels: JSON.parse($('.new-shipment .rates .select-shipping-rate.selected').attr('data-parcels'))
        },
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();

            if (!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeSlideout();

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});